export default __webpack_public_path__ + "static/b235a5bd1d5d39f814943453bc14f3bf.png";